/**
 * Filter Query param Model
 */
export interface IQueryParams {
  searchText?: string,
  status?: string,
  toDate?: Date | null | string,
  fromDate?: Date | null | string
}

export const ButtonProp = {
  apply: 'apply',
  refresh: 'refresh',
  clear: 'clear',
  search: 'search'
};
